// @flow

import * as React from 'react';
import { __RouterContext as RouterContext } from 'react-router';
import hoistStatics from 'hoist-non-react-statics';
import invariant from 'invariant';


const withRouter = (Component) => {
    const displayName = `withRouter(${Component.displayName || Component.name})`;

    let C = (props: Object) => {
        const { forwardedRef, ...remainingProps } = props;

        return (
            <RouterContext.Consumer>
                {(context) => {
                    invariant(context, `You should not use <${displayName} /> outside a <Router>`);
                    return (
                        <Component
                            {...remainingProps}
                            {...context}
                            ref={forwardedRef}
                        />
                    );
                }}
            </RouterContext.Consumer>
        );
    };

    C.displayName = displayName;
    C.WrappedComponent = Component;

    C = hoistStatics(C, Component);

    return React.forwardRef((props: Object, ref: React.Ref<typeof Component>) => (
        <C {...props} forwardedRef={ref} />
    ));
};

export default withRouter;
